import { CURRENCY_MAP } from "./constants";

export const formatCurrency = (amount, currencyCode = "USD") => {
  const num = Number(amount);
  const currency = CURRENCY_MAP[currencyCode] || CURRENCY_MAP["USD"];
  const decimals = currency.decimals !== undefined ? currency.decimals : 2;
  if (isNaN(num))
    return `${currency.symbol}0${decimals > 0 ? "." + "0".repeat(decimals) : ""}`;
  const parts = num.toFixed(decimals).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${currency.symbol}${parts.join(".")}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatDateForInput = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const isImageFile = (file) => {
  return file && file.type && file.type.startsWith("image/");
};

export const isPdfFile = (file) => {
  return file && file.type === "application/pdf";
};

export const isReceiptFile = (file) => {
  return isImageFile(file) || isPdfFile(file);
};
